// extracted by mini-css-extract-plugin
export default {"overlay":"IrSHMZZ","opacityIn":"bEr2OIn","modalWrapper":"QPR08Og","opacityOut":"HntZ0j8"};